// Dependencies
import React, { useRef, useState } from 'react';

import classnames from 'classnames';
// eslint-disable-next-line lodash/import-scope
import { get } from 'lodash';
import PropTypes from 'prop-types';

import {
  Impression,
  ImpressionContext,
} from '@nerdwallet/analytics/react/impression';
import {
  getDeployableInfo,
  useAnalyticsPageView,
} from '@nerdwallet/seo-analytics';

// Utils

import { cdnUri } from '@nerdwallet/nw-client-lib/cdn';

const imgUri = cdnUri('img/diy/hac', 'png');

const justRegistered = (identity) => {
  // HACK: to check if a user is registering or signing in
  // Look at the account created at timestamp and see if it within last 5 mins
  const createdAt = new Date(get(identity, 'current.created_at'));
  const timestampNow = new Date();

  return timestampNow - createdAt <= 300000;
};

const AuthModal = ({
  children,
  className,
  driverLocation,
  flow,
  flowConfig,
  impressionPayload,
  onClick,
  onSignIn,
  onRegistration,
  tracking,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isRegistration, setIsRegistration] = useState(false);

  const ref = useRef();
  const { pageName, pageViewId } = useAnalyticsPageView();

  const onAuthSuccess = (identity) => {
    // onAuthSuccess only gets triggered when the user has completed
    // ALL the steps in the flow
    onSignIn(identity);
  };

  const onStateChange = ({ identity }) => {
    // onStateChange gets triggered every time
    // there are changes in auth dialog redux state
    // i.e. every step in the flow will trigger 1 or more onStateChange
    if (!isAuthenticated && get(identity, 'isSignedIn', false)) {
      setIsAuthenticated(true);
    }

    onSignIn(identity);

    if (!isRegistration && justRegistered(identity)) {
      setIsRegistration(true);

      onRegistration(identity);
    }
  };

  const showAuthDialog = (impressionId) => {
    if (typeof window !== 'undefined') {
      const {
        deployable_name: deployableName,
        deployable_version: deployableVersion,
      } = getDeployableInfo();
      window.nwapi.ui.showAuthDialog({
        version: 2,
        onSuccess: onAuthSuccess,
        onStateChange,
        flowConfig,
        flow,
        trk: {
          trk_mode: 'modal',
          trk_channel: 'web',
          trk_element: 'ad_unit',
          trk_copy: tracking,
          trk_location: tracking,
          navigation_source_impression_id: impressionId,
        },
        segmentTrackingAttributes: {
          deployableName,
          deployableVersion,
          driverPageName: pageName,
          driverPageViewId: pageViewId,
          driverLocation: driverLocation || tracking,
          driverElement: 'ad_unit',
        },
      });
    }
  };

  const handleClick = (e, impressionId) => {
    if (typeof window !== 'undefined') {
      e.preventDefault();
      e.stopPropagation();
    }

    onClick();
    showAuthDialog(impressionId);
  };

  return (
    <Impression {...impressionPayload}>
      <ImpressionContext.Consumer>
        {({ impressionId }) => (
          <div
            ref={ref}
            onClick={(e) => handleClick(e, impressionId)}
            className={classnames('auth-modal', className)}
          >
            {children}
          </div>
        )}
      </ImpressionContext.Consumer>
    </Impression>
  );
};

AuthModal.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  driverLocation: PropTypes.string,
  flow: PropTypes.string,
  flowConfig: PropTypes.object,
  onClick: PropTypes.func,
  onSignIn: PropTypes.func,
  onRegistration: PropTypes.func,
  tracking: PropTypes.string,
  impressionPayload: PropTypes.object,
};

AuthModal.defaultProps = {
  flow: 'credit-score',
  flowConfig: {
    slides: [
      {
        copy: 'Get your score, see your rate.',
        image: imgUri('house-slider-bg-score'),
      },
      true,
      true,
    ],
  },
  onSignIn: () => {},
  onRegistration: () => {},
  onClick: () => {},
  tracking: null,
  className: '',
  impressionPayload: {},
};

export default AuthModal;
